import BaseSetup from '@/components/BaseSetup';
import useTagService from '@/services/tag/TagService';
import { Reactive } from '@/utils/decorators';
import { } from 'vue';

export type SharedTagQuickFilterEmits = {
	(e: 'update:modelValue', val: number[]): void
};

export type SharedTagQuickFilterProps = {
	modelValue?: number[]
};

export default class SharedTagQuickFilterSetup extends BaseSetup {

	static readonly defaultProps = { modelValue: () => [] };

	@Reactive private readonly state = { tagsList: [] as ITagListItemModel[] };

	get valueAsLinkModel () {
		return this.state.tagsList
			.filter(x => this.props.modelValue?.includes(x.id))
			?.map(x => ({
				id: 0,
				linkId: 0,
				tagId: x.id,
				tagName: x.name,
				tagColorName: (x.color?.name?.replace(/(grad|light)/, 'alt') ?? 'default') as Orion.ColorExtended,
			}));
	}

	constructor (
		private props: SharedTagQuickFilterProps,
		private emits: SharedTagQuickFilterEmits,
	) {
		super();
	}

	async onBeforeMountAsync () {
		this.state.tagsList = await useTagService().listAsync();
	}

	updateFilter (tag: ITagListItemModel) {
		this.emits('update:modelValue', [...(this.props.modelValue ?? [])].toggle(tag.id));
	}

}
